import React from "react";
import { TextField } from "../../../../../shared/TextField";
import { FormattedMessage } from "react-intl";
import { Table } from "reactstrap";

function GroupFields({ formikProps, group }) {

  return (
    <Table className="align-items-center table-flush" responsive striped>
      <tbody>
      <tr>
        <td>
          <FormattedMessage id="fields.group_name"/>
        </td>
        <td className="pt-0 pb-0">
          <TextField
            name="groupName"
            value={formikProps.values.groupName}
            classNameFormGroup="m-0"
            onChange={(e) =>
              formikProps.setFieldValue( "groupName", e.target.value )
            }
          />
        </td>
      </tr>
      </tbody>
    </Table>
  );
}

export { GroupFields };
